import { useState, useEffect, useRef } from "react";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });

  useEffect(() => {
    function onResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", onResize);
    onResize();

    return () => window.removeEventListener("resize", onResize);
  }, []);

  return windowSize;
}

function useClickOutsideSvg(callback) {
  const r2 = useRef();
  useEffect(() => {
    function onOutsideClick(event) {
      if (
        r2.current &&
        r2.current.tagName === "path" &&
        event.target.tagName === "path"
      ) {
        r2.current = event.target;
        return;
      }
      if (
        r2.current &&
        r2.current.tagName !== event.target.tagName &&
        !event.target.id.includes("button")
      ) {
        callback();
      }
      r2.current = event.target;
    }

    document.addEventListener("mousedown", onOutsideClick, false);

    return () =>
      document.removeEventListener("mousedown", onOutsideClick, false);
  });
}

export { useWindowSize, useClickOutsideSvg as useClickedOutsideElement };
